import Input from 'components/Input';
import MaskedInput from 'components/MaskedInput';
import Select from 'components/Select';
import { FormikTouched } from 'formik';
import { EstadoCivilProps } from 'pages/Register/utils/personProps';
import {
  FormPropsType,
  FormPropsWithNoAvalistaType,
} from 'pages/Register/utils/types/FormPropType/FormPropType';
import React, { useState } from 'react';
import * as S from './styles';

type InputsAndSelectsOfBasicInformationProps = {
  values: FormPropsType | FormPropsWithNoAvalistaType;
  errorsForm: FormPropsType | FormPropsWithNoAvalistaType | undefined;
  successForm: FormPropsType | FormPropsWithNoAvalistaType | undefined;
  touched: FormikTouched<FormPropsType>;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  maritalStatusList: EstadoCivilProps[];
  nacionalidades: { id: number; descricao: string }[];
  isModifying?: boolean;
};

export const InputsAndSelectsOfBasicInformation: React.FC<
  InputsAndSelectsOfBasicInformationProps
> = ({
  values,
  errorsForm,
  successForm,
  touched,
  setFieldValue,
  maritalStatusList,
  nacionalidades,
  isModifying,
}) => {
  const [editMother] = useState(values?.mae ? true : false);
  const [editDate] = useState(values?.aniversario ? true : false);

  return (
    <S.Wrapper>
      <S.DivInput>
        <Input
          readOnly={!isModifying}
          name="nome"
          title="Nome completo"
          value={values.nome}
          maxInputLength={50}
          error={errorsForm?.nome === 'true' && successForm?.nome === 'false'}
          valid={
            !!values.nome && !!touched.nome && errorsForm?.nome === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('nome', event.target.value);
          }}
        />
        <MaskedInput
          readOnly={editDate && !isModifying}
          name="aniversario"
          title="Data de nascimento"
          inputMethod="numeric"
          value={values.aniversario}
          MaskType={'dateDMA'}
          maxInputLength={10}
          error={
            errorsForm?.aniversario === 'true' &&
            successForm?.aniversario === 'false'
          }
          valid={
            !!values.aniversario &&
            !!touched.aniversario &&
            errorsForm?.aniversario === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('aniversario', event.target.value);
          }}
        />
        <Select
          title="Sexo"
          name="sexo"
          value={values.sexo}
          error={errorsForm?.sexo === 'true' && successForm?.sexo === 'false'}
          valid={
            !!values.sexo && !!touched.sexo && errorsForm?.sexo === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            setFieldValue('sexo', event.target.value);
          }}
        >
          <option value="" hidden>
            Selecione uma opção
          </option>
          <option value="M">Masculino</option>
          <option value="F">Feminino</option>
          <option value="N">Não Declarado</option>
        </Select>

        <Select
          name="estadoCivil"
          title="Estado Civil"
          error={
            errorsForm?.estadoCivil === 'true' &&
            successForm?.estadoCivil === 'false'
          }
          valid={
            !!values.estadoCivil &&
            !!touched.estadoCivil &&
            errorsForm?.estadoCivil === 'false'
          }
          value={values.estadoCivil}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            setFieldValue('estadoCivil', event.target.value);
          }}
        >
          <option value="" hidden>
            Selecione uma opção
          </option>
          {maritalStatusList.length > 0 &&
            maritalStatusList.map((item: EstadoCivilProps) => (
              <option value={item.descricao} key={item.id}>
                {item.descricao}
              </option>
            ))}
        </Select>

        <Input
          readOnly={editMother && !isModifying}
          name="mae"
          title="Nome da mãe"
          value={values.mae}
          maxInputLength={50}
          error={errorsForm?.mae === 'true' && successForm?.mae === 'false'}
          valid={!!values.mae && !!touched.mae && errorsForm?.mae === 'false'}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('mae', event.target.value);
          }}
        />

        <Select
          name="nacionalidade"
          title="Nacionalidade"
          value={values.nacionalidade?.id || ''}
          error={
            !!touched.nacionalidade &&
            !!errorsForm?.nacionalidade &&
            !successForm?.nacionalidade
          }
          valid={
            !!values.nacionalidade &&
            !!touched.nacionalidade &&
            !!successForm?.nacionalidade
          }
          onChange={(e) => {
            const selectedId = parseInt(e.target.value);
            const selected = nacionalidades.find(
              (nac) => nac.id === selectedId
            );
            setFieldValue('nacionalidade', selected);
          }}
        >
          <option value="" hidden>
            Selecione uma opção
          </option>
          {nacionalidades.map((nac) => (
            <option key={nac.id} value={nac.id}>
              {nac.descricao}
            </option>
          ))}
        </Select>

        {/* <Input
          name="nomeConjuge"
          title="Nome do Cônjuge"
          value={values.nomeConjuge}
          maxInputLength={50}
          error={
            errorsForm?.nomeConjuge === 'true' &&
            successForm?.nomeConjuge === 'false'
          }
          valid={
            !!values.nomeConjuge &&
            !!touched.nomeConjuge &&
            errorsForm?.nomeConjuge === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('nomeConjuge', event.target.value);
          }}
        />

        <MaskedInput
          name="cpfConjuge"
          title="CPF do Cônjuge"
          MaskType="cpf"
          inputMethod="numeric"
          value={values.cpfConjuge}
          maxInputLength={14}
          error={
            errorsForm?.cpfConjuge === 'true' &&
            successForm?.cpfConjuge === 'false'
          }
          valid={
            !!values.cpfConjuge &&
            !!touched.cpfConjuge &&
            errorsForm?.cpfConjuge === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('cpfConjuge', event.target.value);
          }}
        /> */}
      </S.DivInput>
    </S.Wrapper>
  );
};
